import * as React from "react"

import axios from 'axios'

import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'

import { useRouterStore } from 'mobx-state-router'
import { useRootStore } from 'contexts'

import { TRAILS_SPOTS_EXPORTS_ENDPOINT } from 'Api'

import FixedToolbar from 'components/FixedToolbar'
import MainLayoutVh from 'layouts/MainVh'

import {
    Grid,
    Button,
    Typography,
    TextField
} from '@material-ui/core'


const ExportsScreen = () => {

    const routerStore = useRouterStore()
    const rootStore = useRootStore()
    const { ratingsStore } = rootStore
    const authStore = rootStore.authStore;



    const doExport = () => {
        const organisationId = authStore.selectedOrganisation.id
        const downloadUrl = `${TRAILS_SPOTS_EXPORTS_ENDPOINT}/${organisationId}`
        axios({
            url: downloadUrl,
            method: 'GET',
            responseType: 'blob'
        })
            .then((response) => {
                console.log("reponse");
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'download.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })

    }

    
    const toolbar = <FixedToolbar>
          </FixedToolbar>

  return <MainLayoutVh toolbar={toolbar} >
        <Container maxWidth="sm">
            <Box
                border={1}
                color="primary.main"
                bgcolor="background.paper"
                fontFamily="h6.fontFamily"
                fontSize={{ xs: 'h6.fontSize', sm: 'h4.fontSize', md: 'h3.fontSize' }}
                p={{ xs: 2, sm: 3, md: 4 }}
            >
<Button
                onClick={() => doExport()}
                color="primary"
                //disabled={!formState.isValid}
                size="medium"
                type="submit"
                variant="contained">export organisaton trail spots</Button>
            </Box>
            
        </Container>
   </MainLayoutVh>
}

export default ExportsScreen;